import AvatarData from './AvatarData';

export default class Client {
  id = 0;

  firstName = '';

  lastName = '';

  profileImage: { url: string } = { url: '' };

  get fullName(): string {
    if (!this.lastName) return this.firstName;

    const lastInitial = `${this.lastName.substr(0, 1)}.`;
    return `${this.firstName} ${lastInitial}`;
  }

  get avatarData(): AvatarData {
    return {
      avatarName: this.fullName,
      primaryText: this.fullName,
      src: this.profileImage.url,
    };
  }
}
